module.exports = __webpack_public_path__ + "img/dog2.6c69985d.svg";